import { fallback as viem_fallback } from 'viem';
export function fallback(transports, config) {
    return viem_fallback(transports, config);
}
//# sourceMappingURL=fallback.js.map